// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-visible"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 19C12 19 13.4974 22.4998 17 22.5C20.5026 22.5002 22 19 22 19C22 19 20.5026 15.4977 17 15.5C13.4974 15.5023 12 19 12 19Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H9M8 6H16M8 6V2H16V6M16 6V4H20V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.75 19H17.25M17 22.5C13.4974 22.4998 12 19 12 19C12 19 13.4974 15.5023 17 15.5C20.5026 15.4977 22 19 22 19C22 19 20.5026 22.5002 17 22.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskVisibleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-visible',
    ref,
    icon: element,
  },
));

TaskVisibleIcon.displayName = 'TaskVisibleIcon';

export default TaskVisibleIcon;
